import React, { memo } from 'react'
import { useDispatch } from 'react-redux'
import { ISpotBiddingRule } from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import {
  openAddSpotBiddingRuleModal,
  openDeleteSpotBiddingRuleModal,
} from 'apps/spot-quote-control-panel/utils/actions/spotBiddingConfig'
import { Dropdown, IDropdownOption, DropdownIconType } from 'components/forms'

export const RuleActions = memo<{ rule: ISpotBiddingRule }>(({ rule }) => {
  const dispatch = useDispatch()

  const options: IDropdownOption[] = [
    { label: 'Edit Rule', action: () => dispatch(openAddSpotBiddingRuleModal(rule)) },
    {
      label: 'Delete Rule',
      action: () => {
        if (rule.id) dispatch(openDeleteSpotBiddingRuleModal(rule))
      },
    },
  ]

  return <Dropdown options={options} icon={DropdownIconType.ellipsis} />
})
